export const createPasswordForgot = (body) => {
  return fetch('/api/v1/password/forgot', {
    method: 'POST',
    body: JSON.stringify(body),     
    headers: {'Content-Type': 'application/json', 'Accept': 'application/json' }
  })
  .then(res => res.json())
}